import {number2money} from "@/utils/common.ts";
import {isNil, get} from 'lodash-es'
// 处理金额
export function moneyRender(text) {
    const num =isNaN(Number(text))?0:Number(text) ;
    let _value = num.toFixed(2);
    _value = number2money(_value)
    return _value
}
const { getUser } = window.microApp?.getData?.() || {}
export { getUser }
  /**
 * 是否为空 null undefined ''
 * @param field 字段名称
 */
export const isNilOrNull = (field: any) => {
  field = typeof field === 'string' ? field?.trim() : field
  return isNil(field) || field === '' ? true : false
}
/**
 * 获取图片路径
 * @param imgObj 图片对象
 */
export const getImgRelativePath = (imgObj) => {
  return get(imgObj, 'response.data.filePath') || get(imgObj, 'relativePath')
}
//  * 是否是有效的数组
//  * @param arr 数组
//  */
export const isValidArray = arr => {
  return arr && Array.isArray(arr) && arr.length > 0 ? true : false
}

/**
 * 获取Origin
 * @returns
 */
export const getOrigin = () => {
  return window.location.origin;
}